TS.ns('WL');

WL.partnerViewModel = new Class({
    Extends: WL.EditBase,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        me.canEditShareholders = ko.computed(function () {
            if (me.CanEditShareholders())
                return true;
            return false;
        });

        me.watchProperty(me.Document.UniqueID, me.onUniqueIdChanged, me);

        var addressList = me.getDomainProperty('dgPartnerAddress_Property');
        var contactList = me.getDomainProperty('dgContactInfoCollection_Property');
        var propertyList = me.getDomainProperty('PropertyList');
        var workplaceList = me.getDomainProperty('dgPersonWorkplaceCollection_Property');
        var goodsList = me.getDomainProperty('dgPartnerGoodsCollection_Property');
        var accountList = me.getDomainProperty('grdBankAccountCollection_Property');
        var activityList = me.getDomainProperty('grdPartnerActivityFieldCollection_Property');
        var shareholderList = me.getDomainProperty('grdPartnerShareholders_Property');
        var incomeList = me.getDomainProperty('dgPartnerIncomeCollection_Property');

        if (addressList) {
            addressList.on('afterAdd', me.onAddressAdded);
        }

        if (propertyList) {
            propertyList.on('beforeAdd', me.onBeforePropertyAdded);
            propertyList.on('addNew', me.onPropertyAdded);
            propertyList.on('cellValueChanged', me.onPropertyChanged, me);
            propertyList.on('beforeDelete', me.onPropertyIsDeleted);
            propertyList.on('cellBeginEdit', me.onPropertyCellBeginEdit)
        }

        if (contactList) {
            contactList.on('afterAdd', me.onContactAdded);
            contactList.getFieldByName('gcUniqueID_Field').allowInput = false;
            contactList.getFieldByName('gcUniqueID_Field').on('propertyChanged', me.onUniqueIDChanged, me);

            contactList.getFieldByName('gcUniqueIDForSupplier_Field').allowInput = false;
            contactList.getFieldByName('gcUniqueIDForSupplier_Field').on('propertyChanged', me.onUniqueIDChanged, me);

            if (me.IsDealerUser()) {
                contactList.getFieldByName('gcUniqueID_Field').Visible(false);
            }
            else {
                contactList.getFieldByName('gcUniqueIDForSupplier_Field').Visible(false);
            }
        }

        if (workplaceList) {
            workplaceList.on('afterAdd', me.onWorkplaceAdded);

            workplaceList.getFieldByName('gcUniqueID_Field').allowInput = false;
            workplaceList.getFieldByName('gcUniqueIDForDealers_Field').allowInput = false;
            if (me.IsDealerUser()) {
                workplaceList.getFieldByName('gcUniqueIDForDealers_Field').on('propertyChanged', me.onUniqueEmployerIDChanged, me);
                workplaceList.getFieldByName('gcUniqueID_Field').Visible(false);
            }
            else {
                workplaceList.getFieldByName('gcUniqueID_Field').on('propertyChanged', me.onUniqueEmployerIDChanged, me);
                workplaceList.getFieldByName('gcUniqueIDForDealers_Field').Visible(false);
            }
        }

        if (goodsList) {
            var cat = goodsList.Commands;

            newCmd = new TS.domain.Command();;
            newCmd['Code'] = 'EditGoodsProperties';
            newCmd['Text'] = me.EditGoodsPropertiesCommandText;
            newCmd['handler'] = '_editGoodsProperties';
            newCmd['IconCode'] = 'ellipsis-v';

            if (!me.ReadOnly())
                cat.push(newCmd);

            goodsList.on('afterAdd', me.onGoodsAdded);
        }

        if (accountList) {
            accountList.getFieldByName('gcBank_Field').allowInput = false;
        }

        if (activityList) {
            activityList.getFieldByName('gcCAEN_Field').allowInput = false;
            activityList.getFieldByName('gcCAEN_Field').on('propertyChanged', me.onActivityFieldChanged, me);
        }

        if (shareholderList) {
            shareholderList.getFieldByName('gcUniqueID_Field').allowInput = false;
            shareholderList.getFieldByName('gcUniqueID_Field').on('propertyChanged', me.onShareholderChanged, me);
            shareholderList.getFieldByName('gcUniqueIDForDealers_Field').allowInput = false;
            shareholderList.getFieldByName('gcUniqueIDForDealers_Field').on('propertyChanged', me.onShareholderChanged, me);

            $.each(shareholderList.Commands(), function (index, item) {
                if (item.Code == "Add" || item.Code == "Delete")
                    item.InternalVisible = me.CanEditShareholders;
            });

            shareholderList.on('cellBeginEdit', me.onShareholdersGridBeginEdit);

            if (me.IsDealerUser()) {
                shareholderList.getFieldByName('gcUniqueID_Field').Visible(false);
            }
            else {
                shareholderList.getFieldByName('gcUniqueIDForDealers_Field').Visible(false);
            }
        }

        if (incomeList) {
            if (me.IsDealerUser()) {
                incomeList.getFieldByName('gcSourcePartner_Field').Visible(false);
            }
            else {
                incomeList.getFieldByName('gcSourcePartnerForDealers_Field').Visible(false);
            }
        }


        var consentList = me.getDomainProperty('grdDisplayedConsentCollection_Property');

        if (consentList) {
            consentList.on('cellValueChanged', me.onConsentValueChanged, me);

            consentList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.content.children("table").children("tbody").children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        var dcell = row.children().eq(7);
                        var daLink = dcell.children().children();
                        daLink.removeAttr("target");
                        daLink.attr("href", "javascript:TS.UI.models.peek().UploadToDMS(" + dataItem.ConsentTypeId + ")");
                        var cell = row.children().eq(1);
                        var aLink = cell.children().children();
                        if (dataItem.IsUploaded == false) {
                            aLink.attr("href", "#");
                            aLink.addClass("ts-command-disabled");
                        }
                        else {
                            aLink.attr("href", "javascript:TS.UI.models.peek().DownloadFromDMS(" + dataItem.ConsentTypeId + ")");
                        }
                    }
                }
            }
        }
    },

    onUniqueIdChanged: function (e) {
        var me = this;

        if (me.IsFromOCR() === false)
            me.performServerCommand('LoadPartner', true, null);

        me.IsFromOCR(false);
    },

    onShareholdersGridBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (!owner.CanEditShareholders()) {
            e.preventDefault();
        }
    },

    onShareholderChanged: function (selectedRecord) {
        var me = this,
            shareHolderList = me.getDomainProperty('grdPartnerShareholders_Property');

        if (selectedRecord.sender.SelectedItem()) {
            shareHolderList.SelectedItem().ShareHolderPartnerName(selectedRecord.sender.SelectedItem().PartnerName);
            shareHolderList.SelectedItem().ShareHolderPartnerPhone(selectedRecord.sender.SelectedItem().ClientPhone);
        }
    },

    onActivityFieldChanged: function (selectedRecord) {
        var me = this,
            activityFieldList = me.getDomainProperty('grdPartnerActivityFieldCollection_Property')

        activityFieldList.SelectedItem().ActivityFieldName(selectedRecord.sender.SelectedItem().DictionaryItemName);
    },

    onContactAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        owner.performServerCommand('Dummy', true, null);
    },

    onUniqueIDChanged: function (selectedRecord) {
        var me = this,
            contactList = me.getDomainProperty('dgContactInfoCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            setTimeout(function () {
                me.performServerCommand({
                    cmd: 'LoadContactInfo',
                    submitModel: true,
                    extraData: { UniqueID: selectedRecord.sender.SelectedItem().UniqueID, UID: contactList.SelectedItem().UID },
                    blockUI: true
                });
            }, 0)
        }
    },

    onWorkplaceAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        owner.performServerCommand('Dummy', true, null);
    },

    onUniqueEmployerIDChanged: function (selectedRecord) {
        var me = this,
            workplaceList = me.getDomainProperty('dgPersonWorkplaceCollection_Property');
        if (selectedRecord.sender.SelectedItem()) {
            me.performServerCommand({
                cmd: 'LoadEmployerInfo',
                submitModel: true,
                extraData: { UniqueID: selectedRecord.sender.SelectedItem().UniqueID, UID: workplaceList.SelectedItem().UID },
                blockUI: true
            });
        }
    },

    onAddressAdded: function (e) {
        var me = this,
            rec = e.item,
            owner = me._getOwner();

        rec.CountryId = new ko.observable(owner.DefaultCountryId());
        rec.CountryName = new ko.observable(owner.DefaultCountryName());
    },

    onBeforePropertyAdded: function (e) {
        var me = this,
            owner = me._getOwner(),
            rec = e.item;

        if (owner.ReadOnlyProperties())
            e.preventDefault();
    },

    onPropertyAdded: function (e) {
        var me = this,
            rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text');
        rec.EditorType = new ko.observable('Text');
    },

    onPropertyChanged: function (e) {
        var me = this,
            rec = e.item;

        if (e.fieldName != 'PropertyId')
            return;

        me.performServerCommand({
            cmd: 'RefreshProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx
            },
            blockUI: true
        })
    },

    onPropertyCellBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner(),
            rec = e.item;
        if (owner.ReadOnlyProperties())
            e.preventDefault();
    },

    onPropertyIsDeleted: function (e) {
        var me = this,
            owner = me._getOwner();

        if (owner.ReadOnlyProperties()) {
            e.preventDefault();
        }
    },

    _editGoodsProperties: function () {
        var me = this;

        var goodsList = me.getDomainProperty('dgPartnerGoodsCollection_Property');
        if (goodsList.SelectedItem() == null)
            return;

        me.performServerCommand({
            cmd: 'EditPartnerGoods',
            submitModel: true,
            extraData: { UID: goodsList.SelectedItem().UID() },
            blockUI: false
        });
    },

    onGoodsAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        owner.performServerCommand('Dummy', true, null);
    },

    _createCommands: function () {
        var me = this,
            cat;

        me.parent();

        cat = me.CommandCategories.Navigation.commands;

        if (cat != null)
            for (var i = 0; i < cat.length; i++) {
                if (cat[i].Code == "AddPartner") cat[i].handler = '_addPartner';
                if (cat[i].Code == "Reports") {
                    for (var j = 0; j < cat[i].commands.length; j++) {
                        cat[i].commands[j].handler = "_showReport";
                    }
                }
            }
    },

    _showReport: function (e) {
        var me = this;
        me.performServerCommand('Navigation.Reports.' + e.Code, true, null,
            function (r) {
                var me = this;

                if (r.modelData == undefined)
                    return;

                if (!r.modelData.ReportExportIsHtml)
                    return;

                var url = me.rootUrl + '/../Handlers/GetReport.ashx' + "?ReportId=" + r.modelData.ReportExportId + r.modelData.ReportExportParameters;
                window.open(url, '_blank');
            });
    },

    onReportGridBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        e.Code = 'Report' + e.record.ReportId();
        owner._showReport(e);
    },

    onConsentValueChanged: function (e) {
        var me = this;

        me.performServerCommand({
            cmd: 'ConsentCheckValueChanged',
            submitModel: true,
            extraData: {
                ConsentTypeId: e.record.ConsentTypeId
            },
            blockUI: true
        });
    },

    UploadToDMS: function (e) {
        var me = this;


        me.performServerCommand({
            cmd: 'UploadDocument',
            submitModel: true,
            extraData: {
                ConsentTypeId: e
            },
            blockUI: true
        });
    },

    DownloadFromDMS: function (e) {
        var me = this;

        me.performServerCommand({
            cmd: 'DownloadDocument',
            submitModel: true,
            extraData: {
                ConsentTypeId: e
            },
            blockUI: true
        });
    }
});